"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWithinDeleteTimeLimit = isWithinDeleteTimeLimit;
/**
 * Decides if a time overcome the asset day limit time to delete.
 */
function isWithinDeleteTimeLimit(createdTime, assetDeleteDaysLimit) {
  var assetCreationDate = new Date(createdTime).getTime();
  var now = Date.now();
  var timeDiff = now - assetCreationDate;
  return timeDiff < assetDeleteDaysLimit * 24 * 60 * 60 * 1000;
}
//# sourceMappingURL=utils.js.map